import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class GrnItemReceivedQtyRequest {
    @ApiProperty()
    @IsNumber()
    @IsNotEmpty()
    grnId: number;
    @ApiProperty()
    @IsNumber()
    @IsNotEmpty()
    itemId: number
    @ApiProperty()
    @IsNumber()
    @IsNotEmpty()
    itemCategoryId: number;
}